import React from "react";
import styles from "./menu.module.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { LOCALES } from "../../constants";
// import { MdLibraryMusic } from "react-icons/md";

export default function Menu({ to }) {
    const lang = useSelector((state) => state.lang.value);

    let kor = "";
    let eng = "";

    switch (to) {
        case "arcana":
            kor = "아르카나";
            eng = "Arcana";
            break;
        case "savior":
            kor = "구원자";
            eng = "Savior";
            break;
        case "deck":
            kor = "덱 구성";
            eng = "Deck Build";
            break;
        case "journey":
            kor = "여정";
            eng = "Journey";
            break;
        case "schedule":
            kor = "스케줄러";
            eng = "Scheduler";
            break;
        case "gacha":
            kor = "가챠";
            eng = "Gacha";
            break;
        case "item":
            kor = "여정 아이템";
            eng = "Journey Item";
            break;
        case "monster":
            kor = "몬스터 정보";
            eng = "Monster Info";
            break;
        case "potential":
            kor = "잠재력";
            eng = "Potential";
            break;
        case "music":
            kor = "BGM";
            eng = "BGM";
            break;
        case "wallpaper":
            kor = "월페이퍼";
            eng = "Wallpaper";
            break;
        case "simulator/savior":
            kor = "구원자 시뮬레이터";
            eng = "Savior Simulator";
            break;
    }

    return (
        <Link to={to} className={styles["menu"]}>
            {to !== "music" && to !== "wallpaper" && to !== "simulator/savior" && to !== "monster" && to !== "potential" && (
                <img src={`${process.env.PUBLIC_URL}/images/index/${to}.png`} />
            )}
            {to === "music" && <i className="fi fi-rs-music-alt" />}
            {to === "wallpaper" && <i className="fi fi-rr-desktop-wallpaper" />}
            {to === "simulator/savior" && <i className="fi fi-rr-dashboard-monitor" />}
            {to === "monster" && <i className="fi fi-rr-skull" />}
            {to === "potential" && <i className="fi fi-rr-sparkles" />}
            <h3>{lang === LOCALES.KO ? kor : eng}</h3>
        </Link>
    );
}
